<template>
  <!-- Header -->
  <div class="header bg-color-customization" ref="header">
    <!-- Logo -->
    <div class="header-left">
      <router-link to="admin-dashboard" class="logo">
        <img
          src="@/assets/img/logo-whiteAsset-1.png"
          width="60"
          height="50"
          alt="Logo"
        />
      </router-link>
      <router-link to="admin-dashboard" class="logo2">
        <img
          src="@/assets/img/logo-whiteAsset-1.png"
          width="60"
          height="40"
          alt="Logo"
        />
      </router-link>
      <!-- Mobile and Tablet -->
      <div class="company-name-mobile">
        <h3>{{ companyName }}</h3>
      </div>
      <!-- Mobile and Tablet -->
    </div>
    <!-- /Logo -->

    <a id="toggle_btn" href="javascript:void(0);" @click="toggleSidebar">
      <span class="bar-icon">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </a>

    <!-- Header Title -->
    <div class="page-title-box">
      <h3>{{ companyName }}</h3>
    </div>
    <!-- /Header Title -->

    <a
      id="mobile_btn"
      class="mobile_btn"
      href="#sidebar"
      @click="toggleSidebar1"
      ><i class="fa-solid fa-bars"></i
    ></a>

    <!-- Header Menu -->
    <ul class="nav user-menu">
      <!-- Search -->
      <li class="nav-item">
        <div class="top-nav-search position-relative">
          <!--<a href="javascript:void(0);" class="responsive-search">
            <i class="fa-solid fa-magnifying-glass"></i>
          </a>-->
          <router-link to="search" class="responsive-search"
            ><i class="fa-solid fa-magnifying-glass"></i
          ></router-link>
          <!-- <form @submit.prevent="submitForm">
            <input
              class="form-control"
              type="text"
              @blur="submitForm"
              v-model="searchValue"
              placeholder="Search here"
            />
            <button class="btn" type="submit">
              <i class="fa-solid fa-magnifying-glass"></i>
            </button>
          </form> -->
          <form @submit.prevent="handleSearchSubmit">
            <input
              class="form-control"
              type="text"
              v-model="searchValue"
              @input="debouncedSearch"
              placeholder="Search here"
            />
            <button class="btn" type="submit">
              <i class="fa-solid fa-magnifying-glass"></i>
            </button>
          </form>
          <ul
            v-if="searchResults.length && searchValue"
            class="dropdown-menu show search-dropdown"
          >
            <li
              v-for="(item, index) in searchResults"
              :key="index"
              @click="navigateTo(item.path)"
              class="dropdown-item"
              style="cursor: pointer"
            >
              {{ item.name }}
            </li>
          </ul>
          <!-- </div> -->
        </div>
      </li>
      <!-- /Search -->

      <!-- Flag -->
      <!-- <li class="nav-item dropdown has-arrow flag-nav">
        <a
          class="nav-link dropdown-toggle"
          data-bs-toggle="dropdown"
          href="javascript:;"
          role="button"
        >
          <img src="@/assets/img/flags/us.png" alt="Flag" height="20" />
          <span>English</span>
        </a>
        <div class="dropdown-menu dropdown-menu-right">
          <a href="javascript:void(0);" class="dropdown-item">
            <img src="@/assets/img/flags/us.png" alt="Flag" height="16" /> English
          </a>
          <a href="javascript:void(0);" class="dropdown-item">
            <img src="@/assets/img/flags/fr.png" alt="Flag" height="16" /> French
          </a>
          <a href="javascript:void(0);" class="dropdown-item">
            <img src="@/assets/img/flags/es.png" alt="Flag" height="16" /> Spanish
          </a>
          <a href="javascript:void(0);" class="dropdown-item">
            <img src="@/assets/img/flags/de.png" alt="Flag" height="16" /> German
          </a>
        </div> 
      </li>-->
      <!-- /Flag -->

      <!-- Notifications -->
      <li class="nav-item dropdown">
        <a
          href="javascript:;"
          class="dropdown-toggle nav-link"
          data-bs-toggle="dropdown"
        >
          <i class="fa-regular fa-bell"></i>
          <span v-if="globalNotificationsBadge" class="badge rounded-pill">{{
            globalNotificationsBadge
          }}</span>
        </a>
        <div class="dropdown-menu notifications">
          <div class="topnav-dropdown-header">
            <span class="notification-title">Notifications</span>
            <a
              href="javascript:void(0)"
              class="clear-noti"
              @click="setNotificationClear"
            >
              Clear All
            </a>
          </div>
          <div class="noti-content">
            <ul class="notification-list">
              <li
                class="notification-message"
                v-for="(data, index) in globalNotifications"
                :key="index"
              >
                <router-link to="#" @click="updateLastReadNotificationID(data)">
                  <div class="chat-block d-flex">
                    <span class="avatar flex-shrink-0">
                      <img
                        v-if="data?.avatar && data?.avatar != null"
                        :src="getEmployeeAvatar(data?.avatar)"
                        @error="handleNImageError(data)"
                      />
                      <img
                        v-else
                        src="@/assets/img/profiles/avatar-01.jpg"
                        alt="User Image"
                      />
                    </span>
                    <div class="media-body flex-grow-1">
                      <p class="noti-details" v-if="data?.first_name">
                        <span :class="{ 'noti-title': !data?.has_read }">{{
                          data?.message
                        }}</span>
                        By {{ data?.first_name }} {{ data?.last_name }}
                      </p>
                      <p class="noti-time">
                        <span class="notification-time">{{
                          convertDate(data?.created_at)
                        }}</span>
                      </p>
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
          <div class="topnav-dropdown-footer">
            <router-link to="activities">View all Notifications</router-link>
          </div>
        </div>
      </li>
      <!-- /Notifications -->

      <!-- Message Notifications -->
      <!-- <li class="nav-item dropdown">
        <a
          href="javascript:;"
          class="dropdown-toggle nav-link"
          data-bs-toggle="dropdown"
        >
          <i class="fa-regular fa-comment"></i>
          <span class="badge rounded-pill">8</span>
        </a>
        <div class="dropdown-menu notifications">
          <div class="topnav-dropdown-header">
            <span class="notification-title">Messages</span>
            <a href="javascript:void(0)" class="clear-noti"> Clear All </a>
          </div>
          <div class="noti-content">
            <ul class="notification-list">
              <li class="notification-message">
                <router-link to="chat">
                  <div class="list-item">
                    <div class="list-left">
                      <span class="avatar">
                        <img
                          src="@/assets/img/profiles/avatar-01.jpg"
                          alt="User Image"
                        />
                      </span>
                    </div>
                    <div class="list-body">
                      <span class="message-author">Richard Miles </span>
                      <span class="message-time">12:28 AM</span>
                      <div class="clearfix"></div>
                      <span class="message-content"
                        >Lorem ipsum dolor sit amet, consectetur
                        adipiscing</span
                      >
                    </div>
                  </div>
                </router-link>
              </li>
              <li class="notification-message">
                <router-link to="chat">
                  <div class="list-item">
                    <div class="list-left">
                      <span class="avatar">
                        <img
                          src="@/assets/img/profiles/avatar-01.jpg"
                          alt="User Image"
                        />
                      </span>
                    </div>
                    <div class="list-body">
                      <span class="message-author">John Doe</span>
                      <span class="message-time">6 Mar</span>
                      <div class="clearfix"></div>
                      <span class="message-content"
                        >Lorem ipsum dolor sit amet, consectetur
                        adipiscing</span
                      >
                    </div>
                  </div>
                </router-link>
              </li>
              <li class="notification-message">
                <router-link to="chat">
                  <div class="list-item">
                    <div class="list-left">
                      <span class="avatar">
                        <img
                          src="@/assets/img/profiles/avatar-01.jpg"
                          alt="User Image"
                        />
                      </span>
                    </div>
                    <div class="list-body">
                      <span class="message-author"> Tarah Shropshire </span>
                      <span class="message-time">5 Mar</span>
                      <div class="clearfix"></div>
                      <span class="message-content"
                        >Lorem ipsum dolor sit amet, consectetur
                        adipiscing</span
                      >
                    </div>
                  </div>
                </router-link>
              </li>
              <li class="notification-message">
                <router-link to="chat">
                  <div class="list-item">
                    <div class="list-left">
                      <span class="avatar">
                        <img
                          src="@/assets/img/profiles/avatar-01.jpg"
                          alt="User Image"
                        />
                      </span>
                    </div>
                    <div class="list-body">
                      <span class="message-author">Mike Litorus</span>
                      <span class="message-time">3 Mar</span>
                      <div class="clearfix"></div>
                      <span class="message-content"
                        >Lorem ipsum dolor sit amet, consectetur
                        adipiscing</span
                      >
                    </div>
                  </div>
                </router-link>
              </li>
              <li class="notification-message">
                <router-link to="chat">
                  <div class="list-item">
                    <div class="list-left">
                      <span class="avatar">
                        <img
                          src="@/assets/img/profiles/avatar-01.jpg"
                          alt="User Image"
                        />
                      </span>
                    </div>
                    <div class="list-body">
                      <span class="message-author"> Catherine Manseau </span>
                      <span class="message-time">27 Feb</span>
                      <div class="clearfix"></div>
                      <span class="message-content"
                        >Lorem ipsum dolor sit amet, consectetur
                        adipiscing</span
                      >
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
          <div class="topnav-dropdown-footer">
            <router-link to="chat">View all Messages</router-link>
          </div>
        </div>
      </li> -->
      <!-- /Message Notifications -->
      
      <li class="nav-item dropdown">
       <router-link to="/hierarchy" class="dropdown-item"
            ><i class="fa-solid fa-sitemap"></i></router-link
          >
      </li>

      <li class="nav-item dropdown has-arrow main-drop">
        <a
          href="javascript:;"
          class="dropdown-toggle nav-link"
          data-bs-toggle="dropdown"
        >
          <span class="user-img me-1">
            <img
              v-if="this.user?.avatar && this.user?.avatar != null"
              :src="getEmployeeAvatar(this.user?.avatar)"
              alt="User Image"
              @error="handleImageError()"
              class="user-avatar-1" />
            <img
              v-else
              :src="require(`@/assets/img/profiles/${defaultAvatar}`)"
              alt="User Image"
              class="user-avatar-1" />
            <span class="status online"></span
          ></span>
          <span>{{ this.user?.first_name }} {{ this.user?.last_name }}</span>
        </a>
        <div class="dropdown-menu">
          <router-link :to="'/profile/' + this.user?.id" class="dropdown-item"
            >My Profile</router-link
          >
          <router-link to="/change-password" class="dropdown-item"
            >Update Password</router-link
          >
          <!-- <router-link class="dropdown-item" to="settings">Settings</router-link> -->
          <!--<router-link class="dropdown-item" to="/">Logout</router-link> -->
          <a
            href="javascript:void(0)"
            class="dropdown-item"
            @click.prevent="logout"
            >Logout</a
          >
        </div>
      </li>
    </ul>
    <!-- /Header Menu -->

    <!-- Mobile Menu -->
    <div class="dropdown mobile-user-menu">
      <a
        href="javascript:;"
        class="nav-link dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        ><i class="fa-solid fa-ellipsis-vertical"></i
      ></a>
      <div class="dropdown-menu dropdown-menu-right">
        <router-link class="dropdown-item" :to="'/profile/' + user?.id"
          >My Profile</router-link
        >
        <!-- <router-link class="dropdown-item" to="settings">Settings</router-link> -->
        <!-- <router-link class="dropdown-item" to="/">Logout</router-link>-->
        <a
          href="javascript:void(0)"
          class="dropdown-item"
          @click.prevent="logout"
          >Logout</a
        >
      </div>
    </div>
    <!-- /Mobile Menu -->
  </div>
  <!-- /Header -->

  <div
    id="action_required_notice_modal"
    class="modal custom-modal fade"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ actionRequiredNotice?.title }}</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="dismissActionRequiredNotice"
          >
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <p class="mb-2">{{ actionRequiredNotice?.message }}</p>
          <p class="mb-0">{{ actionRequiredNotice?.description }}</p>
          <div class="submit-section mt-3">
            <button
              type="button"
              class="btn btn-primary submit-btn"
              @click="handleBuyNow"
            >
              Buy Now
            </button>
            <button
              type="button"
              class="btn btn-secondary submit-btn"
              @click="dismissActionRequiredNotice"
              style="margin-left: 10px"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Subscription Notices -->
  <div v-if="visibleNotices.length" class="subscription-notice-container">
    <div
      v-for="(notice, index) in visibleNotices"
      :key="index"
      :class="['subscription-notice', notice.priority]"
    >
      <div class="notice-content">
        <h5>{{ notice.title }}</h5>
        <p>{{ notice.description }}</p>
        <p>{{ notice.message }}</p>
        <small v-if="notice.valid_upto">
          Valid up to: {{ formatDate(notice.valid_upto) }}
        </small>
      </div>
      <button class="dismiss-btn" @click="dismissNotice(index)">×</button>
    </div>
  </div>
  <!-- Subscription Notices -->

  <sidesettings></sidesettings>
</template>

<script>
import moment from "moment";
import axios from "axios";
import * as bootstrap from "bootstrap";
import { mapActions } from "vuex";
import { routes } from "../../router";

export default {
  data() {
    return {
      user: null,
      notifications: [],
      searchValue: "",
      companyName: "",
      defaultAvatar: "avatar-01.jpg",
      searchResults: [],
      allMenus: [],
      searchTimeout: null,
      visibleNotices: [],
      actionRequiredNotice: null,
      actionRequiredNoticeModal: null,
    };
  },
  methods: {
    ...mapActions(["toggleSidebar1"]),
    convertDate(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    },
    toggleSidebar() {
      const body = document.body;
      body.classList.toggle("mini-sidebar");
    },
    // toggleSidebar1() {
    //   const body = document.body;
    //   body.classList.toggle("slide-nav");
    // },
    // submitForm() {
    //   if (this.searchValue != "") {
    //     this.$router.push("/search?search=" + this.searchValue);
    //   }
    // },
    handleSearchSubmit() {
      const keyword = this.searchValue.trim().toLowerCase();

      if (!keyword) return;

      const match = this.allMenus.find(
        (item) => item.name.toLowerCase() === keyword
      );

      if (match) {
        this.$router.push(match.path);
      } else {
        this.$router.push(
          `/search?search=${encodeURIComponent(this.searchValue)}`
        );
      }
    },
    navigateTo(path) {
      // this.searchValue = "";
      this.searchResults = [];
      this.$router.push(path);
    },
    flattenMenu(menuList) {
      let flat = [];
      menuList.forEach((item) => {
        flat.push({ name: item.name, path: item.path });
        // if (item.children && item.children.length) {
        //   flat.push(...this.flattenMenu(item.children));
        // }
      });
      return flat;
    },
    debouncedSearch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        const keyword = this.searchValue.toLowerCase();
        this.searchResults = this.allMenus.filter((item) =>
          item.name.toLowerCase().includes(keyword)
        );
      }, 300);
    },
    logout: function () {
      //localStorage.setItem('token','');
      localStorage.clear();
      this.$router.push({ name: "login" }).catch((error) => {});
      return false;
    },
    handleImageError() {
      this.user.avatar = `assets/img/profiles/${this.defaultAvatar}`;
    },
    handleNImageError(data) {
      data.avatar = `assets/img/profiles/${this.defaultAvatar}`;
    },
    getEmployeeAvatar(avatar) {
      return `${process.env.VUE_APP_IMAGE_BASE_URL}${avatar}`;
    },
    loadNotices() {
      try {
        const subscription = JSON.parse(localStorage.getItem("subscription"));
        if (!subscription) return;

        const general = subscription.general_notice || [];
        const customer = subscription.customer_notice || [];
        const notice = subscription.subscription_notices || [];
        

        const priorityOrder = { high: 1, medium: 2, low: 3 };

        let merged = [...notice, ...general, ...customer].sort((a, b) => {
          return (
            (priorityOrder[a.priority] || 99) -
            (priorityOrder[b.priority] || 99)
          );
        });

        const dismissed = JSON.parse(
          localStorage.getItem("dismissedNotices") || "[]"
        );
        merged = merged.filter((n) => !dismissed.includes(n.id));

        this.visibleNotices = merged;

        const dismissedActionRequiredKey = `dismissedActionRequiredNotices_${
          this.user?.id || "global"
        }`;
        const dismissedActionRequired = JSON.parse(
          localStorage.getItem(dismissedActionRequiredKey) || "[]"
        );
        const actionRequired = merged.find(
          (n) => n?.action_required === true && !dismissedActionRequired.includes(n.id)
        );
        if (actionRequired) {
          this.actionRequiredNotice = actionRequired;
          this.$nextTick(() => {
            const modalEl = document.getElementById(
              "action_required_notice_modal"
            );
            if (!modalEl) return;
            this.actionRequiredNoticeModal = new bootstrap.Modal(modalEl, {
              backdrop: "static",
              keyboard: false,
            });
            this.actionRequiredNoticeModal.show();
          });
        }
      } catch (e) {
        console.error("Error loading notices:", e);
      }
    },
    handleBuyNow() {
      const link = this.actionRequiredNotice?.action_link;
      if (!link) {
        this.dismissActionRequiredNotice();
        return;
      }

      this.dismissActionRequiredNotice();

      if (/^https?:\/\//i.test(link)) {
        window.location.href = link;
        return;
      }

      this.$router.push(link).catch((error) => {});
    },
    dismissActionRequiredNotice() {
      try {
        const dismissedActionRequiredKey = `dismissedActionRequiredNotices_${
          this.user?.id || "global"
        }`;
        const dismissedActionRequired = JSON.parse(
          localStorage.getItem(dismissedActionRequiredKey) || "[]"
        );
        const noticeId = this.actionRequiredNotice?.id;

        if (noticeId && !dismissedActionRequired.includes(noticeId)) {
          dismissedActionRequired.push(noticeId);
          localStorage.setItem(
            dismissedActionRequiredKey,
            JSON.stringify(dismissedActionRequired)
          );
        }
      } catch (e) {}

      if (this.actionRequiredNoticeModal) {
        this.actionRequiredNoticeModal.hide();
      }
      this.actionRequiredNotice = null;
    },
    dismissNotice(index) {
      const dismissed = JSON.parse(
        localStorage.getItem("dismissedNotices") || "[]"
      );
      const noticeId = this.visibleNotices[index].id;

      if (noticeId && !dismissed.includes(noticeId)) {
        dismissed.push(noticeId);
        localStorage.setItem("dismissedNotices", JSON.stringify(dismissed));
      }

      this.visibleNotices.splice(index, 1);
    },
    formatDate(date) {
      if (!date) return "";
      return moment(date).format("DD MMM YYYY");
    },
    async fetchCompanyName() {
      try {
        const response = await axios.get("/company");

        if (
          response.data &&
          response.data.record &&
          response.data.record.length > 0
        ) {
          this.companyName = response.data.record[0].company_name;
        }
      } catch (error) {
        console.error("Error fetching company name:", error);
      }
    },
    updateLastReadNotificationID(data = null) {
      data.has_read = true;

      if (this.globalNotifications?.length) {
        var token = window.localStorage.getItem("token");
        axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;

        var form = new FormData();
        form.append(
          "global_notification_users_id",
          data?.global_notification_users_id || ""
        );

        axios
          .post("/set-read-notification-id", form)
          .then((response) => {
            this.$store.commit(
              "SET_GLOBAL_NOTIFICATION_BADGE",
              this.$store.state.globalNotificationsBadge - 1
            );
          })
          .catch((error) => {
            console.log("error :: ", error);
          });
      }
    },
    setNotificationClear() {
      if (this.globalNotifications?.length) {
        var token = window.localStorage.getItem("token");
        axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;

        var form = new FormData();
        form.append(
          "global_notification_users_id",
          parseInt(
            this.globalNotifications[0]?.global_notification_users_id,
            10
          ) || ""
        );
        axios
          .post("/set-last-cleared-notification-id", form)
          .then((response) => {
            this.$store.commit("SET_GLOBAL_NOTIFICATION_DATA_INITIAL", []);
            this.$store.commit("SET_GLOBAL_NOTIFICATION_BADGE", 0);
          })
          .catch((error) => {
            console.log("error :: ", error);
          });
      }
    },
  },
  mounted() {
    // // Add scroll event listener
    // window.addEventListener("scroll", () => {
    //   var scroll = window.pageYOffset || document.documentElement.scrollTop;
    //   var header = document.getElementsByClassName("header")[0];

    //   if (scroll < 100) {
    //     header.classList.remove("sticky");
    //   } else {
    //     header.classList.add("sticky");
    //   }
    // });
    this.fetchCompanyName();
    this.loadNotices();
    // Add click event listener
    this.$nextTick(() => {
      document.addEventListener("click", this.handleToggleClick);
    });

    // Add mouseover event listener
    document.addEventListener("mouseover", (event) => {
      event.stopPropagation();

      var body = document.body;
      var toggleBtn = document.getElementById("toggle_btn");
      var sidebar = document.getElementsByClassName("sidebar")[0];
      var subdropUL = document.getElementsByClassName("subdrop");

      if (
        toggleBtn &&
        body.classList.contains("mini-sidebar") &&
        toggleBtn.style.display !== "none"
      ) {
        var target = event.target.closest(".sidebar");

        if (target) {
          body.classList.add("expand-menu");
          for (var i = 0; i < subdropUL.length; i++) {
            var ul = subdropUL[i].nextElementSibling;
            if (ul) {
              ul.style.display = "block";
            }
          }
        } else {
          body.classList.remove("expand-menu");
          for (var i = 0; i < subdropUL.length; i++) {
            var ul = subdropUL[i].nextElementSibling;
            if (ul) {
              ul.style.display = "none";
            }
          }
        }

        event.preventDefault();
      }
    });

    const body = document.body;
    body.classList.remove("slide-nav");
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleToggleClick);
  },
  created() {
    let user = localStorage.getItem("user");

    if (user && user != null) {
      user = JSON.parse(user);
    }

    this.user = user ? user : null;

    let permissions = this.user?.permissions?.permissions || {};
    permissions = JSON.parse(permissions);

    const menuList = routes
      .filter((route) => {
        const permKey = route.meta?.permissionKey;
        return (
          permKey &&
          permissions[permKey] &&
          permissions[permKey].read === "true"
        );
      })
      .map((route) => ({
        name: route.meta.title || route.name,
        path: route.path,
      }));

    var user_role = window.localStorage.getItem("role");

    if (user_role && user_role.includes("Employee")) {
      menuList.push({
        name: "Dashboard",
        path: "/employee-dashboard",
        permissionKey: "dashboard",
      });
    } else {
      menuList.push(
        {
          name: "Dashboard",
          path: "/admin-dashboard",
          permissionKey: "dashboard",
        },
        {
          name: "Employee Dashboard",
          path: "/employee-dashboard",
          permissionKey: "employee_dashboard",
        },
        {
          name: "Activity Log",
          path: "/employee-dashboard",
          permissionKey: "activity_log",
        },
        {
          name: "User Permission",
          path: "/employee-dashboard",
          permissionKey: "user_permissions",
        }
      );
    }

    this.allMenus = this.flattenMenu(menuList);

    this.$store.dispatch("getNotificationDetails");
    this.$store.dispatch("fetchDefaultCurrency");
  },
  computed: {
    globalNotifications() {
      return this.$store.state.globalNotifications;
    },
    globalNotificationsBadge() {
      return this.$store.state.globalNotificationsBadge;
    },
  },
  watch: {
    globalNotifications: {
      handler(newVal, oldVal) {},
      deep: true,
    },
  },
};
</script>
<style>
.user-avatar-1 {
  width: 35px !important;
  height: 35px !important;
}

.header.bg-color-customization {
  background: linear-gradient(10deg, #00ddff 0, #8155e5) !important;
}

.header-left {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  overflow: hidden;
}

.company-name-mobile {
  display: none;
}

.search-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 1000;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.search-dropdown .dropdown-item:hover {
  background-color: #ff9b44 !important;
  color: #fff !important;
}

@media (max-width: 992px) {
  .company-name-mobile {
    display: inline-block;
    margin-left: 10px;
    vertical-align: middle;
  }

  .company-name-mobile h3 {
    font-size: 18px;
    margin: 0;
    color: #fff;
  }
}

@media (max-width: 768px) {
  .header-left {
    flex: 1;
  }

  .company-name-mobile h3 {
    font-size: 14px;
    max-width: 150px;
  }
}
@media (max-width: 1060px) {
  .header .page-title-box {
    padding: 20px;
  }
  .header .page-title-box h3 {
    font-size: 18px;
  }
}

.subscription-notice-container {
  background: #f9fafb;
  margin-top: 60px;
  margin-left: 230px;
  padding: 10px 20px;
  border-bottom: 1px solid #ddd;
}

.subscription-notice {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 8px;
  padding: 10px 15px;
  border-radius: 8px;
  color: #333;
  position: relative;
}

.subscription-notice h5 {
  margin: 0 0 4px;
  font-size: 15px;
}

.subscription-notice p {
  margin: 0 0 4px;
  font-size: 13px;
}

.subscription-notice small {
  color: #666;
}

.subscription-notice.high {
  border-left: 5px solid #e53935;
  background: #fdecea;
}

.subscription-notice.medium {
  border-left: 5px solid #ffb300;
  background: #fff8e1;
}

.subscription-notice.low {
  border-left: 5px solid #43a047;
  background: #e8f5e9;
}

.dismiss-btn {
  background: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #666;
  margin-left: 10px;
}

.dismiss-btn:hover {
  color: #000;
}
</style>
